const ReviewLeftBar = () => {
  return (
    <div className="review_left_bar">
      <div className="review_suggestbar">
        <div className="profile_side_menu_list">
          <div className="revw_sugg_head">What makes a good review</div>
          <p className="review_sugg">
            Have you used this product?
            <span>
              Your review should be about your experience with this product.
            </span>
          </p>
          <p className="review_sugg">
            Why review a product?
            <span>
              Your review should be about your experience with this product.
            </span>
          </p>
          <p className="review_sugg no_border">
            How to review a product?
            <span>
              Lorem ipsum dolor sit amet, consectetuer adipi scing elit. Aenean
              commodo ligula eget dolor. Aenean massa. Cum sociis natoque
              penatibus et magnis dis parturient montes, nas cetur ridiculus
              mus. Donec quam felis
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewLeftBar;
